import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = [ "display", "form" ]

    edit() {
        this.displayTarget.style.display = 'none'
        this.formTarget.style.display = 'block'
    }

    cancel() {
        this.displayTarget.style.display = 'block'
        this.formTarget.style.display = 'none'
    }

    // Called when the form is submitted successfully
    connect() {
        // After successful form submission, the Turbo Frame will replace this entire component
        // So we don't need to handle the form submission here
    }
} 